/* eslint-disable no-case-declarations */
import {
  UPDATE_STATE_VALUES,
  REORDER_COLUMNS,
  TOGGLE_COLUMN_VISIBILITY,
  TOGGLE_COLUMN_FIXED,
  SET_COLUMNS_INITIAL_WIDTH,
  TOGGLE_SELECT_ALL,
  TOGGLE_ROW_SELECTION,
  SET_SELECTED_ROWS,
  SELECT_SINGLE_ROW,
  LOAD_MORE_DATA_START,
  LOAD_MORE_DATA,
  LOAD_MORE_DATA_STOP,
  SET_EXPORTABLE_COLUMNS,
  TOGGLE_ROW_EXPANSION,
  ALL_ROWS_SELECTED,
  IS_TABLE_BUSY,
  COLUMN_RESIZE_END
} from "./actions";
import { setColumnsInitialWidth } from "./utils";

const toggleColumnVisiblity = (cols, { key, status }) => {
  return cols.map(c => {
    const newCol = { ...c };
    if (newCol.key === key) {
      newCol.hidden = status;
    }
    return newCol;
  });
};

const toggleColumnFixed = (cols, { key, direction }) => {
  let selectionColumn = null;

  const notSelectionCols = cols.filter(column => {
    if (column.key === "__selection__") {
      selectionColumn = { ...column };
      return false;
    }
    return true;
  });

  const reorderedColumns = notSelectionCols.map(c => {
    const newCol = { ...c };
    if (newCol.key === key) {
      newCol.frozen = newCol.frozen === direction ? false : direction;
    }
    return newCol;
  });

  return [selectionColumn, ...reorderedColumns].filter(Boolean);
};

function reducer(state, action) {
  switch (action.type) {
    case LOAD_MORE_DATA_START:
      return { ...state, isLoadingMore: true };

    case LOAD_MORE_DATA:
      return { ...state, data: [...state.data, ...action.payload] };

    case IS_TABLE_BUSY:
      return { ...state, isLoading: action.payload };

    case LOAD_MORE_DATA_STOP:
      return { ...state, isLoadingMore: false };

    case UPDATE_STATE_VALUES:
      return { ...state, ...action.payload };

    case REORDER_COLUMNS:
      return { ...state, columns: action.payload };

    case TOGGLE_COLUMN_VISIBILITY:
      return {
        ...state,
        columns: toggleColumnVisiblity(state.columns, action.payload)
      };

    case TOGGLE_COLUMN_FIXED:
      return {
        ...state,
        columns: toggleColumnFixed(state.columns, action.payload)
      };

    case SET_EXPORTABLE_COLUMNS:
      return {
        ...state,
        exportableColumnKeys: action.payload
      };

    case SET_COLUMNS_INITIAL_WIDTH:
      return {
        ...state,
        isInitialWidthSet: true,
        tableWidth: action.payload,
        columns: setColumnsInitialWidth(
          state.columns,
          action.payload,
          state.isSelectable
        )
      };

    case TOGGLE_SELECT_ALL:
      return {
        ...state,
        selectedRows:
          action.payload === true
            ? [
                ...state.selectedRows.filter(r =>
                  state.disabledRows.includes(r)
                ),
                ...state.data
                  .filter(
                    row =>
                      !state.disabledRows.includes(row[state.uniqueDataKey])
                  )
                  .map(item => item[state.uniqueDataKey])
              ]
            : state.selectedRows.filter(r => state.disabledRows.includes(r)),
        allRowsSelected: action.payload
      };

    case TOGGLE_ROW_SELECTION:
      return {
        ...state,
        selectedRows: state.selectedRows.includes(action.payload)
          ? state.selectedRows.filter(el => el !== action.payload)
          : [...state.selectedRows, action.payload]
      };

    case SET_SELECTED_ROWS:
      return {
        ...state,
        selectedRows: action.payload
      };

    case TOGGLE_ROW_EXPANSION:
      return {
        ...state,
        expandedRows: state.expandedRows.includes(action.payload)
          ? state.expandedRows.filter(el => el !== action.payload)
          : [...state.expandedRows, action.payload]
      };

    case SELECT_SINGLE_ROW:
      return {
        ...state,
        selectedRow: action.payload
      };

    case ALL_ROWS_SELECTED:
      return {
        ...state,
        allRowsSelected: action.payload
      };

    case COLUMN_RESIZE_END:
      return {
        ...state,
        columns: state.columns.map(column => {
          const newWidth =
            column.key === action.payload.column.key
              ? action.payload.width
              : column.width;
          return {
            ...column,
            width: newWidth
          };
        })
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

export default reducer;
